import { InjectionToken } from '@angular/core';

/**
 * This token is only injected in UI test.
 * Light gallery is disabled bevause it causes e2e tests to fail due to execssive `setTimeout`s.
 * It also does network requests to for license key validation.
 * See: T289814
 */
export const TESTING_MEDIA_VIEWER_DISABLED = new InjectionToken<boolean>(
  'Testing Media Viewer Disabled',
);
